import React from "react";
import { Divider, Box } from "@mui/material";
import {
  IFareBreakdown,
  IItinerary,
  IPriceSummaryTranslations,
} from "@thekilroygroup/shared-ui";
import { IPaymentLine, getTotal } from "redux/shoppingCart";
import { getCurrency } from "utils/numberUtils";
import { FarePriceLine } from "./FarePriceLine";
import { PaymentLine } from "./PaymentLine";
import { TotalPrice } from "./TotalPrice";
import { useSelector } from "react-redux";

interface IPriceSummaryProps {
  itinerary: IItinerary;
  paymentLines: IPaymentLine[];
  priceSummaryTranslations: IPriceSummaryTranslations;
}

export default function PriceSummary(props: IPriceSummaryProps) {
  const { itinerary, paymentLines, priceSummaryTranslations } = props;
  const { pricesFrom, taxAndSurcharges, passengerTypes } =
    priceSummaryTranslations;

  // Use Redux selector to get total that includes payment method fees and discounts
  const totalPrice = useSelector(getTotal);

  return (
    <Box>
      {itinerary.fareBreakdowns.map((fare: IFareBreakdown, index: number) => {
        return (
          <FarePriceLine
            currency={getCurrency(itinerary)}
            key={"payment-line-" + index}
            taxAndSurchargesTitle={taxAndSurcharges}
            taxAndSurchargesAmount={
              fare.fareAmounts.tax * fare.passengerQuantity
            }
            passengerTypes={passengerTypes}
            passengerTypeShort={fare.passengerType}
            passengerQuantity={fare.passengerQuantity}
            priceTotal={fare.fareAmounts.total * fare.passengerQuantity}
          />
        );
      })}

      {paymentLines.map((paymentLine: IPaymentLine, index: number) => {
        return (
          <PaymentLine
            amount={paymentLine.amount}
            label={paymentLine.label}
            currency={getCurrency(itinerary)}
            key={"payment-line-" + index}
          />
        );
      })}
      <Divider sx={{ my: 1 }} />
      <TotalPrice
        pricesFromTitle={pricesFrom}
        currency={getCurrency(itinerary)}
        priceTotal={totalPrice}
      />
    </Box>
  );
}
